export enum EClass {
	USERS = 'users',
	TRAINING = "training",
	EXERCICE = 'exercice'
}
